module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nm-map', {
    attrs: {
      "mapFile": "nm.counties.json",
      "dataFile": "nm_load.csv",
      "res": "Caballo",
      "resFile": "nm.json",
      "whichState": "NM"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "NM"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "nm.counties.json",
      "centersFile": "nm_centers.json",
      "dataFile": "nm-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bdcb911"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/New_Mexico.vue
// module id = 367
// module chunks = 1